import { createListenerMiddleware } from '@reduxjs/toolkit';
import { createListenerEffect } from '@socialive/common';
import { selectUploads } from '@socialive/uploads';
import trackMixPanelEvent from '~/helpers/trackMixPanelEvent';
import { fetchUploadedMediaAsset } from '~/store/recordings';

export const effect = createListenerEffect(
  'portal/trackRecordingUploaded<Listener>',
  async ({ payload, meta }, { dispatch, getState, trigger }) => {
    const { durationSeconds } = payload;
    const { sessionHash } = meta.arg;
    const uploadData = selectUploads(getState())[sessionHash];

    trackMixPanelEvent('Upload Video', {
      Duration: `${durationSeconds} seconds`,
      Size: `${uploadData.uploadSize} bytes`,
    });
  }
);

const { startListening, middleware } = createListenerMiddleware();

startListening({
  actionCreator: fetchUploadedMediaAsset.fulfilled,
  effect,
});

export default middleware;
